import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AuthorizationService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationPostResolve implements Resolve<any> {

  constructor(private authorizationService: AuthorizationService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authorizationService.post(
      route.data.loginInfo || route.params.loginInfo || route.queryParams.loginInfo
    );
  }
}
